import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgChat = function SvgChat(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.953.747H4.046A3.981 3.981 0 00.062 4.732v9.984A3.981 3.981 0 004.046 18.7H14l4.266 4.266c.61.61 1.688.188 1.688-.703v-3.61a3.981 3.981 0 003.984-3.984V4.732c.047-2.203-1.781-3.985-3.984-3.985zM5.015 11.67C3.937 11.67 3 10.78 3 9.654c0-1.079.89-2.016 2.015-2.016 1.078 0 2.016.89 2.016 2.016a2 2 0 01-2.016 2.015zm6.984 0c-1.078 0-2.015-.89-2.015-2.015 0-1.079.89-2.016 2.015-2.016 1.079 0 2.016.89 2.016 2.016A2 2 0 0112 11.669zm6.985 0c-1.078 0-2.016-.89-2.016-2.015 0-1.079.89-2.016 2.016-2.016 1.078 0 2.015.89 2.015 2.016-.046 1.125-.937 2.015-2.015 2.015z"
  }));
};

export default SvgChat;